import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'auth',

  can: {
    route() {
      return this.child;
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/AuthPerimeter.js